import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import {
  KpiPeriod,
  OrgActivity,
  OrgCampaigns,
  OrgHandling,
  OrgKpis,
  OrgNodes,
  OrgsOverviewRow
} from "@/models/org-kpis";
import { IOrgKpisApi } from "./IOrgKpisApi";

@injectable()
export class OrgKpisApi implements IOrgKpisApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/admin/organizations";

  async getOverview(period: KpiPeriod): Promise<OrgsOverviewRow[]> {
    const { data } = await this.client.get<OrgsOverviewRow[]>(`${this.baseUrl}/kpis`, {
      params: period
    });
    return data;
  }

  async getKpis(organizationId: string, period: KpiPeriod): Promise<OrgKpis> {
    const { data } = await this.client.get<OrgKpis>(`${this.baseUrl}/${organizationId}/kpis`, {
      params: period
    });
    return data;
  }

  async getNodes(organizationId: string, period: KpiPeriod): Promise<OrgNodes> {
    const { data } = await this.client.get<OrgNodes>(`${this.baseUrl}/${organizationId}/nodes`, {
      params: period
    });
    return data;
  }

  async getHandling(organizationId: string, period: KpiPeriod): Promise<OrgHandling> {
    const { data } = await this.client.get<OrgHandling>(
      `${this.baseUrl}/${organizationId}/handling`,
      { params: period }
    );
    return data;
  }

  async getCampaigns(organizationId: string, period: KpiPeriod): Promise<OrgCampaigns> {
    const { data } = await this.client.get<OrgCampaigns>(
      `${this.baseUrl}/${organizationId}/campaigns`,
      { params: period }
    );
    return data;
  }

  async getActivity(organizationId: string, period: KpiPeriod): Promise<OrgActivity> {
    const { data } = await this.client.get<OrgActivity>(
      `${this.baseUrl}/${organizationId}/activity`,
      { params: period }
    );
    return data;
  }
}
